module.exports = __webpack_public_path__ + "img/hongkong.400c2a8.svg";